import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Daily.css'; // Reutilizamos estilos
import slide1 from '../assets/cob1.avif';
import slide2 from '../assets/cob2.avif';
import { BarChart3, Receipt } from 'lucide-react';

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const Cobranzas = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      className="dashboard-container"
      initial={isMobile ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      animate={isMobile ? { opacity: 1, y: 0 } : { opacity: 1, y: 0 }}
      exit={isMobile ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      transition={isMobile ? { duration: 0 } : { duration: 0.5 }}
    >
      <div className="title-section">
        <h1 className="dailymenu">Módulo de Cobranzas</h1>
        <div className="title-underline-daily"></div>
        <h1 className="subtitle-daily">Cobranzas</h1>
      </div>

      <div className="daily-menu-grid">
        {/* Card 1: Reporte de Cobranzas */}
        <div className="daily-card" onClick={() => navigate('/reportcob')}>
          <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide1})` }}></div>
          <div className="daily-card-overlay"></div>
          <div className="daily-card-content">
            <div className="daily-card-icon-wrapper">
              <BarChart3 size={28} color="white" />
            </div>
            <h3>Reporte de Cobranzas</h3>
            <p>Análisis de cobro y cumplimiento de cuotas.</p>
          </div>
        </div>

        {/* Card 2: Detalle de Cobranzas */}
        <div className="daily-card" onClick={() => navigate('/detallecob')}>
          <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide2})` }}></div>
          <div className="daily-card-overlay"></div>
          <div className="daily-card-content">
            <div className="daily-card-icon-wrapper">
              <Receipt size={28} color="white" />
            </div>
            <h3>Detalle Cobranzas</h3>
            <p>Detalle histórico de cobros.</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Cobranzas;